package com.dotdrives.web.pages.onboarding

import com.dotdrives.controller.OnboardingUiState
import com.dotdrives.web.ui.DotButton
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

external interface FinishedViewProps : Props {
    var state: OnboardingUiState
    var onExploreDashboard: () -> Unit
}

val FinishedView = FC<FinishedViewProps> { props ->
    val teammateCount = props.state.invites.count { it.email.isNotBlank() }
    val teammateCopy = when (teammateCount) {
        0 -> "Your team can join whenever you're ready."
        1 -> "1 teammate is ready to join you."
        else -> "$teammateCount teammates are ready to join you."
    }
    val importCopy = props.state.importedGiverCount?.let { count ->
        " $count giver${if (count == 1) "" else "s"} imported."
    }.orEmpty()

    div {
        className = ClassName("onboarding-finished")
        div {
            className = ClassName("onboarding-finished-emoji")
            ariaHidden = true
            +"🎉"
        }
        h1 {
            className = ClassName("onboarding-finished-title dot-heading")
            +"You're in, ${props.state.orgName}!"
        }
        p {
            className = ClassName("onboarding-finished-copy")
            +"$teammateCopy$importCopy Your proven five-phase fundraising process is ready."
        }
        DotButton {
            text = "Explore the dashboard →"
            onClick = props.onExploreDashboard
            className = "onboarding-finished-action"
        }
    }
}
